<xemex-authorization-container [isLoading]="store.isSendingResetPasswordEmail()">
  <div class="flex flex-col gap-6">
    <header class="flex flex-col gap-1">
      <h1 class="text-2xl font-bold">{{ 'resetPassword.title' | translate }}</h1>
      <p class="text-sm text-neutral">{{ 'resetPassword.subtitle' | translate }}</p>
    </header>

    @if (store.authFeedback(); as feedback) {
      <xemex-alert-banner [variant]="feedback.variant">
        {{ feedback.key | translate }}
      </xemex-alert-banner>
    }

    <form class="flex flex-col gap-4" (submit)="onResetPassword()">
      <xemex-text-field
        type="email"
        prefixIcon="person"
        autocomplete="email"
        [formControl]="email"
        [label]="'resetPassword.email' | translate"
        [placeholder]="'login.form.placeholderEmail' | translate"
        [invalid]="email.invalid && email.touched"
        [errorText]="
          email.hasError('required')
            ? ('error.required' | translate: { field: 'login.form.email' | translate })
            : email.hasError('email')
              ? ('error.emailInvalid' | translate)
              : ''
        "
      />

      <xemex-filled-button
        type="submit"
        [fullWidth]="true"
        [loading]="store.isSendingResetPasswordEmail()"
      >
        {{ 'resetPassword.btnResetPassword' | translate }}
      </xemex-filled-button>
    </form>

    <a href="/auth/login" class="text-center text-sm font-semibold text-primary hover:underline">
      {{ 'general.btnBackToLogin' | translate }}
    </a>
  </div>
</xemex-authorization-container>
